import { render } from "./TheBreadcrumbInstanzItem.pug?vue&type=template&id=1a9bf51a&lang=pug"
import script from "./TheBreadcrumbInstanzItem.js?vue&type=script&lang=js"
export * from "./TheBreadcrumbInstanzItem.js?vue&type=script&lang=js"

import exportComponent from "/builds/projekte/pvp/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__